'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var qs = require('qs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);

const getClaimsPortalLink = (claimsPortal, retailerMoniker, orderNumber, localeLanguage, localeCountry) => {
  let locale;
  if (localeLanguage) {
    if (localeCountry) {
      locale = `${localeLanguage}_${localeCountry}`;
    } else {
      locale = localeLanguage;
    }
  }
  const queryParams = qs__default["default"].stringify({
    order_number: orderNumber,
    source: 'TRACK_PAGE',
    locale
  });
  return `${claimsPortal}/${retailerMoniker}/assist?${queryParams}`;
};

exports.getClaimsPortalLink = getClaimsPortalLink;
